import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-afiliados',
  templateUrl: './afiliados.component.html',
  styleUrls: ['./afiliados.component.scss']
})
export class AfiliadosComponent implements OnInit {  

  ngOnInit(): void {
  }
  @ViewChild('cuota',{static: true})cuota: NgForm;

  jubilacionminima: any;
  descuentoFijo: any;
  excedente: any;
  cincoSobreExcedente: any;
  TotalAporteTitular: any;
  seguro: any;
  valorConyuge: any;
  Resultado: any
  

  id: any;
  
  constructor() {         

    this.jubilacionminima = 73665; //Octubre 2022
    this.descuentoFijo = 0;
    this.excedente = 0;
    this.cincoSobreExcedente = 0;
    this.TotalAporteTitular = 0;
    this.seguro = 708.50;
    this.valorConyuge = 0;
    this.Resultado =0;    
     
  }


  calculoCuota(){
    
    let haberJubilatorio = Number(this.cuota.value.haberJubilatorio);
    let conyuge = String(this.cuota.value.conyuge);

    this.descuentoFijo = this.jubilacionminima*(7/100);
    this.excedente = haberJubilatorio - this.jubilacionminima;
    this.cincoSobreExcedente = this.excedente*(5/100);
    this.TotalAporteTitular = this.descuentoFijo + this.cincoSobreExcedente;

    if(conyuge == "si"){
      this.valorConyuge = this.TotalAporteTitular*(70/100);
    }
    
    this.Resultado = (this.TotalAporteTitular + this.valorConyuge + this.seguro);
    this.Resultado = this.Resultado.toFixed(2);

    this.reinicio();

    return this.Resultado;     
         
    //this.cuota.reinicio();
    
  }
  reinicio(){
    this.descuentoFijo = 0;
    this.excedente = 0;
    this.cincoSobreExcedente = 0;
    this.TotalAporteTitular = 0;
    this.seguro = 708.50;
    this.valorConyuge = 0;
     
  }

}
